var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-overlay",
              { attrs: { show: _vm.loading } },
              [_c("ReceivedEmailsFilter")],
              1
            ),
            _vm._l(_vm.receivedEmails, function(item) {
              return _c("ReceivedEmailsRow", {
                key: item.id,
                attrs: { item: item.source }
              })
            }),
            !_vm.loading && _vm.receivedEmails.length === 0
              ? _c(
                  "div",
                  { staticClass: "text-center py-5" },
                  [
                    _c("feather-icon", {
                      staticClass: "text-muted mb-2",
                      attrs: { icon: "InboxIcon", size: "48" }
                    }),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v("No se encontraron correos recibidos")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "b-overlay",
              { attrs: { show: _vm.loading } },
              [_c("ReceivedEmailsPagination")],
              1
            )
          ],
          2
        )
      ]),
      _c("ReceivedEmailViewer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }